/*
    Request Token - "abstract" base class for tokens
 */

import angular from "angular";

class RequestToken {
    constructor(tokenTypeName) {
        this._tokenType = tokenTypeName;
        this._tokenParams = {};
    }

    toString() {
        return `Request Token, Type "${this._tokenType}"`;
    }

    get tokenType() {
        return this._tokenType;
    }

    get tokenParams() {
        return this._tokenParams;
    }

    toSearchRequest(childRequests) {
        angular.noop(childRequests);
        return {
            operation: this._tokenType
        };
    }
}

export default RequestToken;


//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/RequestToken.js
// module id = TXT8
// module chunks = 1